"use strict";
/*
 * Created on 10.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionStatusConverter_1 = require("./PromotionStatusConverter");
/**
 * @author MSu
 */


var PromotionStatusConverterImpl =
/*#__PURE__*/
function (_PromotionStatusConve) {
  _inherits(PromotionStatusConverterImpl, _PromotionStatusConve);

  function PromotionStatusConverterImpl() {
    _classCallCheck(this, PromotionStatusConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionStatusConverterImpl).call(this));
  }

  return PromotionStatusConverterImpl;
}(PromotionStatusConverter_1.PromotionStatusConverter);

exports.PromotionStatusConverterImpl = PromotionStatusConverterImpl;